import { asText } from "@prismicio/helpers";
import type { BecomeABussinessCusomerSlice } from "prismicio-types";
import { SliceComponentProps } from "@prismicio/react";
import { useMemo } from "react";
import { wrapIframe } from "@commercekit/shared";

const BecomeABussinessCusomer = ({
  slice,
}: SliceComponentProps<BecomeABussinessCusomerSlice>) => {
  const content = useMemo(() => {
    return wrapIframe(asText(slice.primary.content));
  }, [slice.primary.content]);

  return(
    <div className="col-12 px-0">
      <div className="container">
        <div className="row">
          <div className="col-12">
            {slice.primary.title.length > 0 && (
            <h2 className="heading strong xl underlined left pb-3 mb-3">
                {asText(slice.primary.title)}
              </h2>
            )}
          </div>
          <div className="col-12 col-md-6 pr-lg-4 pr-xl-5 d-flex align-items-center">
            <div
              className="content"
              dangerouslySetInnerHTML={{
                __html: content || "",
              }}
            ></div>
          </div>

          <div className="col-12 col-md-6 px-lg-4 px-xl-5">
            <div className="usps-block w-100">
              <h3 className="usps-block__heading">
                {asText(slice.primary.benefit_title)}
              </h3>

              <ul>
                {slice.items.map((item) => (
                  <li key={asText(item.benefit_text)}>
                    <span className="mr-3">
                      <svg
                        width="36"
                        height="31"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke="null"
                          fill="#E7AE23"
                          d="M31.40536.89784a2.5674 2.5674 0 0 1 3.96932 3.25446l-.03616.04729L13.7701 29.87363a2.5674 2.5674 0 0 1-3.83859.11126l-.03616-.04451L.65214 19.67355a2.5674 2.5674 0 0 1 3.77739-3.47698l.03894.04172 7.26828 8.07494L31.40535.89784z"
                        ></path>
                      </svg>
                    </span>
                    {asText(item.benefit_text)}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}  

export default BecomeABussinessCusomer;
